const compatModules = {};import * as Mod1 from "./discourse/components/follow-button";
compatModules["discourse/components/follow-button"] = Mod1;

export * as discourse$components$follow__button$$__module from "./discourse/components/follow-button";
export {
default as discourse$components$follow__button$$default
} from "./discourse/components/follow-button";
import * as Mod2 from "./discourse/components/follow-notification-preferences";
compatModules["discourse/components/follow-notification-preferences"] = Mod2;

export * as discourse$components$follow__notification__preferences$$__module from "./discourse/components/follow-notification-preferences";
export {
default as discourse$components$follow__notification__preferences$$default
} from "./discourse/components/follow-notification-preferences";
import * as Mod3 from "./discourse/components/follow-statistic";
compatModules["discourse/components/follow-statistic"] = Mod3;

export * as discourse$components$follow__statistic$$__module from "./discourse/components/follow-statistic";
export {
default as discourse$components$follow__statistic$$default
} from "./discourse/components/follow-statistic";
import * as Mod4 from "./discourse/components/follow-users-list";
compatModules["discourse/components/follow-users-list"] = Mod4;

export * as discourse$components$follow__users__list$$__module from "./discourse/components/follow-users-list";
export {
default as discourse$components$follow__users__list$$default
} from "./discourse/components/follow-users-list";
import * as Mod5 from "./discourse/connectors/user-card-additional-buttons/follow-button-container.gjs";
compatModules["discourse/connectors/user-card-additional-buttons/follow-button-container"] = Mod5;

export * as discourse$connectors$user__card__additional__buttons$follow__button__container$$__module from "./discourse/connectors/user-card-additional-buttons/follow-button-container.gjs";
export {
default as discourse$connectors$user__card__additional__buttons$follow__button__container$$default
} from "./discourse/connectors/user-card-additional-buttons/follow-button-container.gjs";
import * as Mod6 from "./discourse/connectors/user-card-metadata/follow-statistics-user-card.gjs";
compatModules["discourse/connectors/user-card-metadata/follow-statistics-user-card"] = Mod6;

export * as discourse$connectors$user__card__metadata$follow__statistics__user__card$$__module from "./discourse/connectors/user-card-metadata/follow-statistics-user-card.gjs";
export {
default as discourse$connectors$user__card__metadata$follow__statistics__user__card$$default
} from "./discourse/connectors/user-card-metadata/follow-statistics-user-card.gjs";
import * as Mod7 from "./discourse/connectors/user-main-nav/follow-user-container.gjs";
compatModules["discourse/connectors/user-main-nav/follow-user-container"] = Mod7;

export * as discourse$connectors$user__main__nav$follow__user__container$$__module from "./discourse/connectors/user-main-nav/follow-user-container.gjs";
export {
default as discourse$connectors$user__main__nav$follow__user__container$$default
} from "./discourse/connectors/user-main-nav/follow-user-container.gjs";
import * as Mod8 from "./discourse/connectors/user-preferences-notifications/follow-notification-preferences-container.gjs";
compatModules["discourse/connectors/user-preferences-notifications/follow-notification-preferences-container"] = Mod8;

export * as discourse$connectors$user__preferences__notifications$follow__notification__preferences__container$$__module from "./discourse/connectors/user-preferences-notifications/follow-notification-preferences-container.gjs";
export {
default as discourse$connectors$user__preferences__notifications$follow__notification__preferences__container$$default
} from "./discourse/connectors/user-preferences-notifications/follow-notification-preferences-container.gjs";
import * as Mod9 from "./discourse/connectors/user-profile-controls/follow-button-container.gjs";
compatModules["discourse/connectors/user-profile-controls/follow-button-container"] = Mod9;

export * as discourse$connectors$user__profile__controls$follow__button__container$$__module from "./discourse/connectors/user-profile-controls/follow-button-container.gjs";
export {
default as discourse$connectors$user__profile__controls$follow__button__container$$default
} from "./discourse/connectors/user-profile-controls/follow-button-container.gjs";
import * as Mod10 from "./discourse/connectors/user-profile-secondary/follow-statistics-user.gjs";
compatModules["discourse/connectors/user-profile-secondary/follow-statistics-user"] = Mod10;

export * as discourse$connectors$user__profile__secondary$follow__statistics__user$$__module from "./discourse/connectors/user-profile-secondary/follow-statistics-user.gjs";
export {
default as discourse$connectors$user__profile__secondary$follow__statistics__user$$default
} from "./discourse/connectors/user-profile-secondary/follow-statistics-user.gjs";
import * as Mod11 from "./discourse/controllers/follow";
compatModules["discourse/controllers/follow"] = Mod11;

export * as discourse$controllers$follow$$__module from "./discourse/controllers/follow";
export {
default as discourse$controllers$follow$$default
} from "./discourse/controllers/follow";
import * as Mod12 from "./discourse/initializers/follow-initializer";
compatModules["discourse/initializers/follow-initializer"] = Mod12;

export * as discourse$initializers$follow__initializer$$__module from "./discourse/initializers/follow-initializer";
export {
default as discourse$initializers$follow__initializer$$default
} from "./discourse/initializers/follow-initializer";
import * as Mod13 from "./discourse/models/post-stream";
compatModules["discourse/models/post-stream"] = Mod13;

export * as discourse$models$post__stream$$__module from "./discourse/models/post-stream";
export {
default as discourse$models$post__stream$$default
} from "./discourse/models/post-stream";
import * as Mod14 from "./discourse/routes/feed";
compatModules["discourse/routes/feed"] = Mod14;

export * as discourse$routes$feed$$__module from "./discourse/routes/feed";
export {
default as discourse$routes$feed$$default
} from "./discourse/routes/feed";
import * as Mod15 from "./discourse/routes/follow";
compatModules["discourse/routes/follow"] = Mod15;

export * as discourse$routes$follow$$__module from "./discourse/routes/follow";
export {
default as discourse$routes$follow$$default
} from "./discourse/routes/follow";
import * as Mod16 from "./discourse/routes/follow/index";
compatModules["discourse/routes/follow/index"] = Mod16;

export * as discourse$routes$follow$index$$__module from "./discourse/routes/follow/index";
export {
default as discourse$routes$follow$index$$default
} from "./discourse/routes/follow/index";
import * as Mod17 from "./discourse/routes/followers";
compatModules["discourse/routes/followers"] = Mod17;

export * as discourse$routes$followers$$__module from "./discourse/routes/followers";
export {
default as discourse$routes$followers$$default
} from "./discourse/routes/followers";
import * as Mod18 from "./discourse/routes/following";
compatModules["discourse/routes/following"] = Mod18;

export * as discourse$routes$following$$__module from "./discourse/routes/following";
export {
default as discourse$routes$following$$default
} from "./discourse/routes/following";
import * as Mod19 from "./discourse/templates/feed";
compatModules["discourse/templates/feed"] = Mod19;

export * as discourse$templates$feed$$__module from "./discourse/templates/feed";
export {
default as discourse$templates$feed$$default
} from "./discourse/templates/feed";
import * as Mod20 from "./discourse/templates/follow";
compatModules["discourse/templates/follow"] = Mod20;

export * as discourse$templates$follow$$__module from "./discourse/templates/follow";
export {
default as discourse$templates$follow$$default
} from "./discourse/templates/follow";
import * as Mod21 from "./discourse/templates/followers";
compatModules["discourse/templates/followers"] = Mod21;

export * as discourse$templates$followers$$__module from "./discourse/templates/followers";
export {
default as discourse$templates$followers$$default
} from "./discourse/templates/followers";
import * as Mod22 from "./discourse/templates/following";
compatModules["discourse/templates/following"] = Mod22;

export * as discourse$templates$following$$__module from "./discourse/templates/following";
export {
default as discourse$templates$following$$default
} from "./discourse/templates/following";
import * as Mod23 from "./discourse/users-route-map";
compatModules["discourse/users-route-map"] = Mod23;

export * as discourse$users__route__map$$__module from "./discourse/users-route-map";
export {
default as discourse$users__route__map$$default
} from "./discourse/users-route-map";
export default compatModules;
